import { createFileRoute } from "@tanstack/react-router";
import { PortalCliente } from "@/components/operacion-portal/cliente/PortalCliente";
import { robotsMeta } from "@/lib/seo";

// El HTML de esta ruta NO contiene datos del cliente: solo la carcasa. Los informes
// llegan por una server function con la cookie de sesión, después de hidratar. Esta
// ruta queda fuera del service worker (alcance /operacion/): nada de esto se cachea.
export const Route = createFileRoute("/cliente-operacion")({
  head: () => ({
    meta: [
      { title: "Resultados de tus activaciones — Improve Yourself" },
      ...robotsMeta(false, false),
    ],
  }),
  component: ClienteOperacionPage,
});

function ClienteOperacionPage() {
  return (
    <main className="min-h-screen bg-background">
      <PortalCliente />
    </main>
  );
}
